import { jsx } from "react/jsx-runtime";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import { validateTidalLicense } from "../../base/index.js";
function FormatAlignLeft(props) {
  return /* @__PURE__ */ jsx(
    FormatAlignLeftIcon,
    {
      "data-testid": "FormatAlignLeft",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatAlignLeft",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
FormatAlignLeft.tidalIconMeta = {
  categories: "editing,attachment",
  name: "FormatAlignLeft"
};
validateTidalLicense();
export {
  FormatAlignLeft
};
//# sourceMappingURL=FormatAlignLeft.js.map
